import { render, staticRenderFns } from "./FormB.vue?vue&type=template&id=d4178cb8&scoped=true&"
import script from "./FormB.vue?vue&type=script&lang=js&"
export * from "./FormB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4178cb8",
  null
  
)

export default component.exports